import gql from 'graphql-tag';

// NOTE: any changes made here should be included in the `content` in the card list queries to avoid re-fetching from the network

export const FeedCardActionsMenuQuery = gql`
	query FeedCardActionsMenuQuery($contentId: ID!) {
		singleContent(id: $contentId) {
			id
			metadata {
				currentuser {
					favourited {
						isFavourite
					}
				}
			}
		}
	}
`;
